"use strict";

const style = require("!!css-loader!./style/index.css").default;

module.exports =`
    <style>${style}</style>
    <details class="swiftref-accordion" >
        <summary class="accordion-title" aria-expanded="false"></summary>
        <div class="accordion-content" hidden role="region">
            <slot></slot>
        </div>
    </details>
`;
